// firebase.js — robust CRA-friendly init for Firestore 12+
// Fixes rare WebChannel/stream assertion errors in dev by enabling
// long polling auto-detect and persistent cache with multi-tab manager.


// src/firebase.js
import { initializeApp } from "firebase/app";
import {
  initializeFirestore,
  getFirestore,
  persistentLocalCache,
  persistentMultipleTabManager,
} from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyA0kcfENiZnBxB8cIkxUWT5R9CLPfWV_4s",
  authDomain: "yourchoiceassociates-49454.firebaseapp.com",
  projectId: "yourchoiceassociates-49454",
  storageBucket: "yourchoiceassociates-49454.firebasestorage.app", // ✅ Correct domain
  messagingSenderId: "392333042560",
  appId: "1:392333042560:web:91c4bfa6216a8a272a239a"
};

const app = initializeApp(firebaseConfig);

// Choose ONE: auto-detect (default) OR force (set via env)
const forceLongPolling = process.env.REACT_APP_FIRESTORE_FORCE_LONG_POLLING === "1";

initializeFirestore(app, {
  ...(forceLongPolling
    ? { experimentalForceLongPolling: true }
    : { experimentalAutoDetectLongPolling: true }),
  localCache: persistentLocalCache({ tabManager: persistentMultipleTabManager() }),
  ignoreUndefinedProperties: true,
});

export const db = getFirestore(app);
export const auth = getAuth(app);
export const storage = getStorage(app);
export default app;